export const SELLER_FEATURES_NAMES = {
  BACKPACK: 'backpackEnabled',
  BACKPRICER: 'backpricerEnabled',
  BACKSHIP: 'backshipEnabled',
  DISTRICT_ADDRESS: 'districtAddressEnabled',
  EPR: 'eprEnabled',
  HYPER_WALLET: 'hwEnabled',
  INSIGHTS: 'insightsEnabled',
  INTERNATIONAL_ONBOARDING: 'internationalOnboardingEnabled',
  KANA_NAME: 'kanaNameEnabled',
  MULTI_ENCODING: 'multiEncodingEnabled',
  PRICING_TOOL: 'pricingToolEnabled',
  SUPPORT: 'supportEnabled',
  VAT: 'vatEnabled',
}
